var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c("div", { staticClass: "report-wrapper" }, [
        _c("p", { staticClass: "time_range" }, [
          _vm._v(
            _vm._s(_vm.formatTime(_vm.data.start_time)) +
              " - " +
              _vm._s(_vm.formatTime(_vm.data.end_time))
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "report_name" }, [
          _vm._v(_vm._s(_vm.data.course_name) + _vm._s(_vm.data.report_name))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "info_detail" }, [
          _c("img", { attrs: { src: _vm.data.head_portrait } }),
          _vm._v(" "),
          _c("p", { staticClass: "user_name" }, [
            _vm._v(_vm._s(_vm.data.user_name))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "statistics" }, [
            _c("div", [
              _c("p", [
                _c("span", [_vm._v("学习总时长")]),
                _c("span", { staticClass: "learn_num" }, [
                  _c("b", [
                    _vm._v(_vm._s(_vm.data.learning_statistics.learning_time))
                  ]),
                  _vm._v("小时")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("p", [
                _c("span", [_vm._v("学习总天数")]),
                _c("span", { staticClass: "learn_num" }, [
                  _c("b", [_vm._v(_vm._s(_vm.data.learning_statistics.days))]),
                  _vm._v("天")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("p", [
                _c("span", [_vm._v("课件完成数")]),
                _c("span", { staticClass: "learn_num" }, [
                  _c("b", [
                    _vm._v(_vm._s(_vm.data.learning_statistics.course_num))
                  ]),
                  _vm._v("个")
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "live_detail" }, [
          _c("p", { staticClass: "live_title" }, [
            _c("span", { staticClass: "font_bold" }, [
              _vm._v("直播"),
              _c("span", { staticClass: "supplementary" }, [
                _vm._v(
                  "共" +
                    _vm._s(_vm.data.learning_statistics.live_num) +
                    "节直播,出勤" +
                    _vm._s(_vm.data.learning_statistics.live_attendance_num) +
                    "节"
                )
              ])
            ]),
            _vm._v(" "),
            _vm.data.learning_statistics.live_num
              ? _c(
                  "span",
                  { staticClass: "godetail", on: { click: _vm.goToLive } },
                  [
                    _vm._v("详情"),
                    _c("img", {
                      attrs: {
                        src: require("../../../static/images/detail.png")
                      }
                    })
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "canvas" }, [
            _c(
              "p",
              [
                _c("el-progress", {
                  attrs: {
                    type: "circle",
                    percentage:
                      (_vm.data.learning_statistics
                        .effective_live_attendance_num /
                        _vm.data.learning_statistics.live_attendance_num) *
                      100,
                    color: "#d44940",
                    width: "70",
                    format: _vm.live_total(
                      _vm.data.learning_statistics
                        .effective_live_attendance_num,
                      _vm.data.learning_statistics.live_num
                    )
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("有效出勤数")])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "p",
              [
                _c("el-progress", {
                  attrs: {
                    type: "circle",
                    color: "#d44940",
                    width: "70",
                    format: _vm.live_total(
                      _vm.data.learning_statistics.live_learning_time
                    )
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("直播净观看时长/h")])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "p",
              [
                _c("el-progress", {
                  attrs: {
                    type: "circle",
                    color: "#d44940",
                    width: "70",
                    format: _vm.live_total(
                      _vm.data.learning_statistics.playback_learning_time
                    )
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("回放净观看时长/h")])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm._m(0)
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "video_detail" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("p", { staticClass: "cumulative_duration" }, [
            _vm._v(
              "累计观看时长：" +
                _vm._s(_vm.data.learning_statistics.video_learning_time) +
                "小时"
            )
          ])
        ]),
        _vm._v(" "),
        _vm.data.bc_id == 0
          ? _c("div", { staticClass: "homework_detail" }, [
              _c("p", { staticClass: "live_title" }, [
                _c("span", { staticClass: "font_bold" }, [
                  _vm._v("作业"),
                  _vm.ua
                    ? _c("span", [_vm._v("可登录学习APP及时处理未完成作业")])
                    : _vm._e()
                ]),
                _vm._v(" "),
                !_vm.ua
                  ? _c(
                      "span",
                      {
                        staticClass: "godetail",
                        on: { click: _vm.goHomeWork }
                      },
                      [
                        _vm._v("详情"),
                        _c("img", {
                          attrs: {
                            src: require("../../../static/images/detail.png")
                          }
                        })
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "正确率：" +
                    _vm._s(_vm.data.learning_statistics.assign_correct_rate)
                )
              ])
            ])
          : _c("div", { staticClass: "homework_detail" }, [
              _c("p", { staticClass: "live_title" }, [
                _c("span", { staticClass: "font_bold" }, [
                  _vm._v("作业"),
                  _vm.ua
                    ? _c("span", [_vm._v("可登录学习APP及时处理未完成作业")])
                    : _vm._e()
                ]),
                _vm._v(" "),
                !_vm.ua
                  ? _c(
                      "span",
                      {
                        staticClass: "godetail",
                        on: { click: _vm.goHomeWork }
                      },
                      [
                        _vm._v("详情"),
                        _c("img", {
                          attrs: {
                            src: require("../../../static/images/detail.png")
                          }
                        })
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "完成数：" +
                    _vm._s(_vm.data.learning_statistics.homework_finish_total) +
                    " / " +
                    _vm._s(_vm.data.learning_statistics.homework_total)
                ),
                _c("span", { staticClass: "right_total" }, [
                  _vm._v(
                    "正确率：" +
                      _vm._s(_vm.data.learning_statistics.homework_rate)
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "平均分：" +
                    _vm._s(_vm.data.learning_statistics.homework_score)
                )
              ])
            ]),
        _vm._v(" "),
        _vm.data.class_teacher_msg ||
        _vm.data.lecturer_msg ||
        _vm.data.assistant_msg
          ? _c("div", { staticClass: "message_detail" }, [
              _vm._m(2),
              _vm._v(" "),
              _vm.data.class_teacher_msg
                ? _c("div", { staticClass: "message_div" }, [
                    _c("p", { staticClass: "message_title" }, [
                      _vm._v("班主任留言")
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.data.class_teacher_msg.suggest)
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.data.lecturer_msg
                ? _c("div", { staticClass: "message_div" }, [
                    _c("p", { staticClass: "message_title" }, [
                      _vm._v("讲师留言")
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.data.lecturer_msg.suggest)
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.data.assistant_msg
                ? _c("div", { staticClass: "message_div" }, [
                    _c("p", { staticClass: "message_title" }, [
                      _vm._v("助教留言")
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(_vm.data.assistant_msg.suggest)
                      }
                    })
                  ])
                : _vm._e()
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "introduce" }, [
      _c("span"),
      _vm._v("有效出勤：直播观看达45分钟或回放观看达50%")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "live_title" }, [
      _c("span", { staticClass: "font_bold" }, [_vm._v("视频")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "live_title" }, [
      _c("span", { staticClass: "font_bold" }, [_vm._v("老师留言")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a5fe8c7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a5fe8c7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/report/index.vue
// module id = null
// module chunks = 